<template>
<div class="ma-0 pa-0">
  <v-snackbar
    centered
    top
    elevation="3"
    :color="notification.type"
    v-model="notifications.snackbar"
    v-for="notification in notifications.notifications"
    :key="notification.id"
    timeout="-1"
  >
    <span class="font-weight-black text-center">
      {{ notification.message }}
    </span>

  <template v-slot:action="{ attrs }">
    <v-btn
      icon
      v-bind="attrs"
      @click="removeNotification(notification)"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </template>
</v-snackbar>
</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: [
    "notification"
  ],
  computed: mapState(["notifications"]),
  data: () => {
    return {
      timer: null,
    }
  },
  methods: mapActions(["removeNotification"]),
  created() {
    this.timer = setTimeout(() => {
      this.removeNotification(this.notification)
    }, 4000)
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
}
</script>